import React from 'react';
import { List, Edit, Create,
    Datagrid, EmailField, FunctionField,
    EditButton, SimpleForm, TextInput } from 'admin-on-rest';

export const UserCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="firstname" />
            <TextInput source="lastname" />
            <TextInput source="email" />
            <TextInput label="Password" source="password" type="password"/>
        </SimpleForm>
    </Create>
);

export const UserList = (props) => (
    <List title="All users" {...props}>
        <Datagrid>
            <FunctionField label="Name" render={record => `${record.lastname} ${record.firstname}`} />
            <EmailField source="email" />
            <EditButton />
        </Datagrid>
    </List>
);

export const UserEdit = (props) => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput source="firstname" />
            <TextInput source="lastname" />
            <TextInput source="email" />
            <TextInput label="Password" source="password" type="password"/>
        </SimpleForm>
    </Edit>
);


// WEBPACK FOOTER //
// src/resources/users.js